var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticStyle:{"position":"relative","height":"650px"}},[_c('v-card',{staticClass:"elevation-0"},[_c('v-card-title',{staticClass:"headline display-1"},[_vm._v(" "+_vm._s(_vm.$t("labels.access_review"))+" ")]),_c('v-card-text',[_c('bar-chart',{attrs:{"chart-data":_vm.collection,"height":500,"width":null}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }